import { Component, inject, LOCALE_ID, signal } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { ConfirmationDialog } from '../../../../shared/ui/confirmation-dialog/confirmation-dialog';
import { SubmitButton } from '../../../../shared/ui/Buttons/submit-button/submit-button';
import { HasScopeDirective } from '../../../../services/scope/has-scope.directive';
import { SCOPES } from '../../../../services/scope/scope-constants';

import { numbersOnlyValidator } from '../instapay-account-create.validators';

@Component({
  selector: 'app-instapay-account-create',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ConfirmationDialog,
    SubmitButton,
    HasScopeDirective,
  ],
  templateUrl: './instapay-account-create.html',
  styleUrl: './instapay-account-create.scss',
})
export class InstapayAccountCreate {
  protected locale = inject(LOCALE_ID);
  private router = inject(Router);

  readonly SCOPES = SCOPES;

  loading = signal<boolean>(false);
  errorCreatingAccount = signal<string | null>(null);

  showCreateDialog = false;

  createTitleAr = 'إضافة حساب إنستا باي';
  createTitleEn = 'Add InstaPay Account';

  createDescriptionAr = 'هل أنت متأكد من إضافة حساب إنستا باي؟';
  createDescriptionEn =
    'Are you sure you want to add this InstaPay account?';

  confirmButtonAr = 'تأكيد';
  confirmButtonEn = 'Confirm';

  cancelButtonAr = 'إلغاء';
  cancelButtonEn = 'Cancel';

  accountForm = new FormGroup({
    instapayAccountNumber: new FormControl('', [
      Validators.required,
      numbersOnlyValidator(),
      Validators.pattern(/^01[0125][0-9]{8}$/),
    ]),
  });

  openCreateDialog() {
    if (this.accountForm.invalid) {
      this.accountForm.markAllAsTouched();
      return;
    }

    this.showCreateDialog = true;
  }

  closeCreateDialog() {
    this.showCreateDialog = false;
  }

  confirmCreate() {
    this.showCreateDialog = false;

    const formValue = this.accountForm.getRawValue();

    /*
      TODO: InstaPay API Integration

      const payload = {
        instapayAccountNumber: formValue.instapayAccountNumber,
      };

      this.loading.set(true);
      this.errorCreatingAccount.set(null);

      this.instapayService.createAccount(payload).subscribe({
        next: () => {
          this.loading.set(false);
          this.router.navigate(['/admin/instapay-accounts']);
        },
        error: (err) => {
          this.loading.set(false);

          // TODO: Handle duplicate InstaPay account error
          this.errorCreatingAccount.set(
            'فشل إضافة حساب إنستا باي. حاول مرة أخرى.'
          );
        },
      });
    */

    console.log(
      'InstaPay Account:',
      formValue.instapayAccountNumber
    );
  }

  onCancel() {
    this.router.navigate(['/admin/instapay-accounts']);
  }
}